import type { HelpFile } from '../../types/help'
import { SapHcmInboundConfigCardTestIds } from '../../../testids/SapHcmInboundConfigCardTestIds'

export const sapHcmInboundConfigCardHelp: HelpFile = {
  docPage: '/docs/connectors/sap-hcm-connector',
  texts: {
    [SapHcmInboundConfigCardTestIds.sapHcmConfigSection]:
      'OData-V2-Eingangskonnektor für SAP HCM. Liest Mitarbeiter-Stammdaten pro Infotyp, löst Gültigkeitsbänder auf und stößt Joiner-/Leaver-Lifecycle-Ereignisse an, wenn STAT2 die konfigurierte Beendigungsgrenze überschreitet.',
    [SapHcmInboundConfigCardTestIds.cardTitleSapHcmConfig]: null,
    [SapHcmInboundConfigCardTestIds.btnEditSapHcmConfig]: null,
    [SapHcmInboundConfigCardTestIds.textSapHcmEmployeeKeyField]:
      'Wire-Feld, das den Mitarbeiter-Schlüssel zum Abrufen der Infotyp-Bänder enthält. Kanonisch in SAP HCM: PERNR. Auf den Feldnamen setzen, den Ihre Wire-Format-Variante verwendet (z. B. mitarbeiterNummer in einer deutschen HR-Hülle).',
  },
}
